<template>
  <div class="pricing-table">
    <div class="plans-grid">
      <div v-for="plan in plans" :key="plan.title" class="plan-col">
        <v-card class="plan-card pa-3 elevation-2">
          <v-card-title class="text-white">{{ plan.title }}</v-card-title>
          <v-card-subtitle class="plan-price">${{ plan.price }} USD</v-card-subtitle>
          <v-card-text>
            <ul class="text-white">
              <li v-for="feature in plan.features" :key="feature">{{ feature }}</li>
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary">Choose Plan</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const basicFeatures = [
  "Monthly technology strategy review",
  "Basic IT infrastructure oversight",
  "Email support",
  "Access to standard industry practices documentation",
  "4 hours of consultancy per month",
];

const standardFeatures = [
  ...basicFeatures,
  "Bi-weekly technology strategy sessions",
  "IT project management",
  "Priority email and phone support",
  "10 hours of consultancy per month",
];

const premiumFeatures = [
  ...standardFeatures,
  "Weekly technology strategy sessions",
  "Dedicated CTO services for project oversight",
  "Real-time chat support",
  "Unlimited consultancy hours",
];

const plans = ref([
  {
    title: "Basic",
    price: 500,
    features: basicFeatures,
  },
  {
    title: "Standard",
    price: 1000,
    features: standardFeatures,
  },
  {
    title: "Premium",
    price: 2000,
    features: premiumFeatures,
  },
]);
</script>

<style scoped>
.pricing-table {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 25px;
}

.plans-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
}

.plan-col {
  flex: 1 1 0%;
  min-width: 250px;
}

.plan-card {
  background: transparent !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 25px !important;
  height: 100%;
}

.plan-price {
  color: #f3d129 !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
  opacity: 1 !important;
}
</style>
